// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"admin","388":"dev"}[chunkId] + "." + {"328":"0dc2b4ff","388":"f33f9593"}[chunkId] + ".js";
};